import { render, staticRenderFns } from "./VueTextArea.vue?vue&type=template&id=72ee42b8&scoped=true&"
import script from "./VueTextArea.vue?vue&type=script&lang=js&"
export * from "./VueTextArea.vue?vue&type=script&lang=js&"
import style0 from "./VueTextArea.vue?vue&type=style&index=0&id=72ee42b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ee42b8",
  null
  
)

export default component.exports